export const text = {
  imgAlt: "apply",
  jobTitle: "RFQ Project Manager",
  pay: "Base Pay: $50,000 - $60,000",
  benefits: "Benefits: Medical, Dental, 401(k)",
};
